import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { FormControlLabel } from 'material-ui/Form';
import Checkbox from 'material-ui/Checkbox';

const styles = theme => ({
  checked: {
    color: theme.palette.primary['A700'],
  },
});

const CheckboxWidget = props => {
  const {
    classes,
    //id,
    value,
    required,
    disabled,
    readonly,
    label,
    autofocus,
    onChange,
  } = props;
  return (
    <FormControlLabel
      control={
        <Checkbox
          //id={id}
          checked={typeof value === 'undefined' ? false : value}
          required={required}
          disabled={disabled || readonly}
          autoFocus={autofocus}
          classes={{
            checked: classes.checked,
          }}
          onChange={event => onChange(event.target.checked)}
        />
      }
      label={label}
    />
  );
};

CheckboxWidget.defaultProps = {
  autofocus: false,
};

CheckboxWidget.propTypes = {
  classes: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  //id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func,
};

export default withStyles(styles)(CheckboxWidget);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/CheckboxWidget.js